import React, { Component } from 'react';
import CreatePlaylistModal from '../features/dashboard/components/playlists-tab/CreatePlaylistModal';
import { Button } from 'react-bootstrap';

class SearchBarWrapper extends Component {
  static defaultProps = {
    onKeyPress: () => {},
    onClick: () => {},
    searchBar: () => {},
    onChange: () => {}
  };

  render() {
    return (
      <>
        <div
          className="ui-search"
          style={{
            backgroundColor: this.props.searchUi ? '#28313b' : ''
          }}
        >
          <CreatePlaylistModal
            show={this.props.showCreatePlaylistModal}
            onClose={this.props.hideModal}
            onCreateNew={this.props.onCreateNew}
            onError={this.props.onError}
            title="New Playlist"
          />
          {this.props.searchUi ? (
            <div className="ui-icon-input">
              <div>
                <span id="spansearch">Search</span>
                <input
                  id="input-string"
                  type="text"
                  onChange={(e) => this.props.onChange(e.target.value)}
                  onKeyPress={this.props.onKeyPress}
                  style={{width: '50%', marginRight: 24}}
                ></input>
                {this.props.addNew !== null && !this.props.addNew && (
                  <span className="spanother" style={{ marginTop: 5}}>
                    Sort
                    <i
                      style={{ marginLeft: '5px', color: '#a09e9e' }}
                      onClick={this.props.onClick}
                      className="fa fa-sort"
                      aria-hidden="true"
                    ></i>
                    </span>
                )}
                <span>
                  <i
                  onClick={this.props.searchBar}
                  className="fa fa-close"
                  aria-hidden="true"
                  style={{paddingLeft: 24}}
                ></i>
                </span>

              </div>
              {this.props.children && (
                <div style={{ display: 'inline-block' }}>
                  {this.props.children}
                </div>
              )}
            </div>
          ) : (
            <i
              onClick={this.props.searchBar}
              className="fa fa-search fa-lg"
              aria-hidden="true"
            ></i>
          )}
        </div>

        {this.props.addNew && (
          <div className="add-new">
            <Button
              // bsClass="custom-button-playlists"
              // style={{
              //   fontWeight: 'bold'
              // }}
              bsClass='login-btn button-oval button-cta2-24'
              onClick={this.props.showModal}
            >
              <i className="fa fa-plus" style={{ marginRight: 5}}></i>
              Create playlist
            </Button>
          </div>
        )}
      </>
    );
  }
}

export default SearchBarWrapper;
